import React, { useMemo } from 'react';
import type { EnterpriseAction } from '../../services/actionService';
import { actionCompletionPct } from '../../utils/issueProgress';

interface ProblemExecutionPanelProps {
  projectName: string | null;
  workflowLinked: boolean;
  actions: EnterpriseAction[];
  onNavigateProject?: () => void;
}

export const ProblemExecutionPanel: React.FC<ProblemExecutionPanelProps> = ({
  projectName,
  workflowLinked,
  actions,
  onNavigateProject,
}) => {
  const stats = useMemo(() => {
    const open = actions.filter(a => a.status !== 'completed' && a.status !== 'cancelled').length;
    const done = actions.filter(a => a.status === 'completed').length;
    const total = actions.length;
    const pct = total > 0 ? Math.round((done / total) * 100) : 0;
    return { open, done, total, pct };
  }, [actions]);

  const rows = [
    { label: 'Projeto relacionado', value: projectName ?? 'Não vinculado', link: !!projectName },
    { label: 'Workflow relacionado', value: workflowLinked ? 'Vinculado' : 'Não vinculado', link: workflowLinked },
    { label: 'Total de ações', value: String(stats.total) },
    { label: 'Ações abertas', value: String(stats.open) },
    { label: 'Ações concluídas', value: String(stats.done) },
    { label: '% execução', value: `${stats.pct}%` },
  ];

  return (
    <div className="space-y-2">
      <div className="grid grid-cols-2 gap-1.5 sm:grid-cols-3">
        {rows.map(r => (
          <div key={r.label} className="rounded border border-slate-200 bg-white px-2 py-1.5 dark:border-slate-700 dark:bg-slate-900">
            <p className="text-[9px] uppercase text-slate-400">{r.label}</p>
            {r.link && onNavigateProject ? (
              <button type="button" onClick={onNavigateProject} className="text-[11px] font-semibold text-blue-600 hover:underline">{r.value}</button>
            ) : (
              <p className="text-[12px] font-semibold text-slate-800 dark:text-slate-200">{r.value}</p>
            )}
          </div>
        ))}
      </div>
      <div>
        <div className="mb-0.5 flex justify-between text-[10px] text-slate-500"><span>Execução</span><span>{stats.pct}%</span></div>
        <div className="h-1.5 overflow-hidden rounded-full bg-slate-200 dark:bg-slate-700">
          <div className="h-full rounded-full bg-indigo-600" style={{ width: `${stats.pct}%` }} />
        </div>
      </div>
    </div>
  );
};
